var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v("\n\t\t\tТОВ \"ЕЙСІ ДІСІ ПРОЦЕССІНГ\"\n\t\t\t"),_c('br'),_vm._v("Повідомлення про внесення відомостей до РПІ: №27-0018/15761 від 22.03.2019\n\t\t\t"),_c('br'),_vm._v("Важливий технологічний оператор платіжних послуг\n\t\t")])])])
}]

export { render, staticRenderFns }